export default __webpack_public_path__ + "static/media/connected-app.2e6f6cd7.png";